import merge from 'lodash/merge';
export function mergeMetaPropsToField(fieldProps, fieldMeta) {
    return merge(fieldProps, fieldMeta);
}
